import * as React from 'react';
import { Note } from '../../types/Note';
import getNotes from '../../requests/getNotes';
import NotesInner from './NotesInner/NotesInner';
import addNote from '../../requests/addNote';
import editNote from '../../requests/editNote';
import deleteNote from '../../requests/deleteNote';

interface Props {
	cardId: number;
}

const Notes: React.FunctionComponent<Props> = props => {
	const [notes, setNotes] = React.useState<Note[]>([]);
	const [loading, setLoading] = React.useState(false);

	const updateNotesList = async () => {
		setLoading(true);

		const result = await getNotes(props.cardId);

		setNotes(result);

		setLoading(false);
	};

	const addNoteRequest = async (text: string) => {
		setLoading(true);

		const request = await addNote({
			cardId: props.cardId,
			note: text
		});

		if (request) {
			updateNotesList();
		}
		else {
			setLoading(false);
		}
	};

	const editNoteRequest = async (noteId: number, note: string) => {
		setLoading(true);

		const request = await editNote({
			noteId,
			note
		});

		if (request) {
			updateNotesList();
		}

		setLoading(false);

		return true;
	};

	const deleteNoteRequest = async (noteId: number) => {
		const request = await deleteNote({
			noteId
		});

		if (request) {
			updateNotesList();
		}

		return true;
	}

	React.useEffect(() => {
		updateNotesList();
	}, [props.cardId]);

	return <NotesInner
		notes={notes}
		addNote={addNoteRequest}
		onEdit={editNoteRequest}
		onDelete={deleteNoteRequest}
		isLoading={loading}
	/>;
};

export default Notes;
